<template>
  <div class="dashboard__container">
    <div class="dashboard__left_stats">
      <div class="dashboard__chart_container">
        <LineChart :data="data" :chartTitle="chartLabel" :labels="labels" />
      </div>
      <div class="dashboard__actions">
        <div class="dashboard__action dashboard__action_green mr_1" @click="goToSection('dashboard_invitations')">
          <p>Personas más invitadas</p>
          <span class="material-icons"
            style="position: absolute; right: 0.5rem; font-size: 22px;">arrow_forward_ios</span>
        </div>
        <div class="dashboard__action dashboard__action_red" @click="goToSection('denied_details')">
          <p>Motivos de Negaciones</p>
          <span class="material-icons"
            style="position: absolute; right: 0.5rem; font-size: 22px;">arrow_forward_ios</span>
        </div>
      </div>
      <div class="dashboard__invitation_type">
        <span>Tipo de Invitaciones</span>
        <table class="dashboard__table w-full">
          <thead>
            <tr>
              <th></th>
              <th class="dashboard__green">Aprobadas</th>
              <th class="dashboard__red">Denegadas</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item of invitationTypes" :key="item.type">
              <td>{{ item.type }}</td>
              <td class="dashboard__green t_align_center arial">{{ item.approved }}</td>
              <td class="dashboard__red t_align_center arial">{{ item.denied }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="dashboard__right_stats">

      <InvitationsDetailTable :items="getSelectedInvitation.data?.invitations" :error="getSelectedInvitation.error"
        :total-items="getSelectedInvitation.data?.total_count || 0"
        :current-page="getSelectedInvitation.data?.page || 1" :loading="getSelectedInvitation.isLoading"
        :rows-per-page="getSelectedInvitation.data?.per_page || 10" @paginate="handlePagination" />

      <!-- <div class="dashboard__card_container">
        <table class="dashboard__table w-full">
          <thead>
          <tr>
            <th></th>
            <th>Aprobadores</th>
            <th class="dashboard__green">Aprobadas</th>
            <th class="dashboard__red">Denegadas</th>
            <th>Aprobación promedio</th>
          </tr>
          </thead>
          <tbody class="dashboard__normal_table">
            <tr v-for="item of approversStats" :key="item.id">
              <td><span class="dashboard__profile_image" :style="{'background-image': `url(${item.photo})`}"></span></td>
              <td>{{ item.name }}</td>
              <td class="dashboard__green t_align_center arial">{{ item.approved }}</td>
              <td class="dashboard__red t_align_center arial">{{ item.denied }}</td>
              <td class="t_align_center arial">{{ item.averageApproval }}</td>
            </tr>
          </tbody>
        </table>
      </div> -->

    </div>
  </div>
</template>
<script>
import DashboardService from '../../../services/DashboardService';
import InvitationsDetailTable from '../../dashboard/InvitationsDetailTable.vue';
import LineChart from '../../shared/charts/LineChart.vue';

export default {
  components: {
    LineChart,
    InvitationsDetailTable
  },
  data() {
    return {
      location: null,
      user: null,
      labels: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      data: [],
      chartLabel: "Invitaciones realizadas 2025",
      invitationTypes: [],
      approversStats: [],
    }
  },
  mounted() {
    this.setLoader(true);

    Promise.all([
      this.getInvitationTypes(),
      this.getApproversStats(),
      this.getYearlyStats(),
    ]).finally(() => {
      this.setLoader(false);
    });
  },
  methods: {
    goToSection(section) {
      const router = {
        name: section,
      }
      this.$router.push(router);
    },
    async handlePagination({ page, perPage }) {
      const params = {
        type: this.getSelectedInvitation.type,
        location_id: this.getLocation || null,
        start_date: this.getStartDate || null,
        end_date: this.getEndDate || null,
        page,
        per_page: perPage
      };

      await this.fetchInvitationDetails(params);
    },
    async getInvitationTypes() {
      console.log("Start Date For Invited Type")
      console.log(this.getStartDate);
      const start_date = this.getStartDate ? new Date(this.getStartDate) : undefined;
      console.log(start_date)
      const end_date = this.getEndDate ? new Date(this.getEndDate) : undefined;
      if (start_date) {
        start_date.setHours(24, 0, 0, 1);
      }
      if (end_date) {
        end_date.setHours(23, 59, 59, 999);
        end_date.setHours(24, 0, 0, 0);
      }
      try {
        const params = {
          user_id: this.getUser || undefined,
          location_id: this.getLocation || undefined,
          start_date,
          end_date,
        }
        this.invitationTypes = await DashboardService.getInvitationTypesStats(params);
      } catch (err) {
        console.error(err);
      }
    },
    async getApproversStats() {
      try {
        const params = {
          location_id: this.getLocation || undefined,
          start_date: this.getStartDate ? new Date(this.getStartDate) : undefined,
          end_date: this.getEndDate ? new Date(this.getEndDate) : undefined,
        }
        this.approversStats = await DashboardService.getApproversStats(params);
      } catch (err) {
        console.error(err);

      }
    },
    async getYearlyStats() {
      try {
        const params = {
          location_id: this.getLocation || undefined,
          start_date: this.getStartDate ? new Date(this.getStartDate) : undefined,
          end_date: this.getEndDate ? new Date(this.getEndDate) : undefined,
        }
        this.data = (await DashboardService.getYearlyStats(params)).map(item => item.count);
      } catch (err) {
        console.error(err);

      }
    }
  },
  watch: {
    'getUser': {
      deep: true,
      handler() {
        this.getInvitationTypes();
        this.getApproversStats();
      }
    },
    'getLocation': {
      deep: true,
      handler() {
        this.getInvitationTypes();
        this.getApproversStats();
      }
    },
    'getStartDate': {
      deep: true,
      handler() {
        this.getInvitationTypes();
        this.getApproversStats();
      }
    }
  }
}
</script>